import { Visibility, VisibilityOff } from "@mui/icons-material";
import { IconButton, InputAdornment, TextField } from "@mui/material";

import _ from "lodash";
import PropTypes from "prop-types";
import { useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { NumericFormat } from "react-number-format";

const CoreNumberFormat = ({
  name,
  label,
  prefix,
  suffix,
  thousandSeparator,
  required,
  placeholder,
  className,
  readOnly,
  disabled,
  hidden,
  hiddenLabel,
  rules,
  fullWidth,
  displayType,
  isAllowed,
  decimalScale,
  inputProps,
  InputProps,
  toggleContent = false,
  isShow = false,
  alwaysShow = false,
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  // const isError = Boolean(_.get(errors, name));
  // const messageError = _.get(errors, name);

  const [showContent, setShowContent] = useState(isShow);
  const handleShowContent = () => setShowContent((show) => !show);

  return (
    <>
      <Controller
        name={name}
        control={control}
        rules={{ ...rules, required: required }}
        render={({ field: { value, onChange } }) => {
          return (
            <>
              <NumericFormat
                className={className}
                hidden={hidden}
                hiddenLabel={hiddenLabel}
                customInput={TextField}
                disabled={readOnly || disabled}
                suffix={suffix}
                label={label}
                displayType={displayType}
                placeholder={placeholder}
                type={showContent || alwaysShow ? "text" : "password"}
                value={value || 0}
                fullWidth={fullWidth}
                helperText={<>{_.get(errors, `${name}.message`)}</>}
                thousandSeparator={thousandSeparator}
                InputLabelProps={{ shrink: true, required }}
                decimalScale={decimalScale}
                onValueChange={(target) => {
                  onChange(target.floatValue);
                }}
                valueIsNumericString
                prefix={prefix}
                isAllowed={isAllowed}
                inputProps={{ ...inputProps }}
                InputProps={{
                  ...InputProps,
                  endAdornment: (
                    <>
                      {toggleContent ? (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleShowContent}
                            // onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {showContent ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ) : null}
                    </>
                  ),
                }}
              />

              {/* {isError && <FormHelperText>{messageError}</FormHelperText>} */}
            </>
          );
        }}
      />
    </>
  );
};

export default CoreNumberFormat;

CoreNumberFormat.defaultProps = {
  className: null,
  name: null,
  label: null,
  decimalScale: 0,
  placeholder: null,
  prefix: "",
  displayType: null,
  suffix: null,
  thousandSeparator: true,
  fullWidth: true,
  required: false,
  readOnly: false,
  disabled: false,
  hidden: false,
  hiddenLabel: false,
  rules: null,
  isAllowed: (values) => true,
};

CoreNumberFormat.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  decimalScale: PropTypes.number,
  prefix: PropTypes.string,
  displayType: PropTypes.string,
  thousandSeparator: PropTypes.bool,
  fullWidth: PropTypes.bool,
  required: PropTypes.bool,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  hidden: PropTypes.bool,
  hiddenLabel: PropTypes.bool,
  rules: PropTypes.object,
  isAllowed: PropTypes.func,
  inputProps: PropTypes.any,
  InputProps: PropTypes.any,
  toggleContent: PropTypes.bool,
};
